<template>
    <div class="step" :class="this.$parent.edit ? 'disabled' : ''">
        <div class="step-header d-none d-md-block">
            <div class="svg-icon"
                 :style="'mask: url(/img/icons/placeholder-blue.svg); -webkit-mask-image: url(/img/icons/placeholder-blue.svg);'"></div>
            {{ $t('titles.address') }}&nbsp;*
            <i v-if="this.$parent.edit">Pro změnu tohoto parametru vytvořte nový odhad</i>
        </div>
        <div v-if="!this.$parent.edit" class="form-group">
            <label for="" class="required font-weight-medium d-md-none">Adresa</label>
            <custom-autocomplete :google-key="apiKey" :cors-url="cors" v-model="place"/>
        </div>
        <div v-else class="form-group">
            <label for="" class="required font-weight-medium d-md-none">Adresa</label>
            <input type="search" id="place" name="place" placeholder="Adresa nebo souřadnice ve tvaru 50.1000593, 13.4360036" autocomplete="off" required="required" class="form-control"
                   v-model="place" readonly>
        </div>
    </div>
</template>

<script>
export default {
    name: "Place",

    data: function () {
        return {
            place: null,
            selected: null,
            apiKey: this.$parent.googleKey,
            cors: this.$parent.googleCors,
        }
    },

    computed: {
        required: function () {
            return this.place != null && this.place.trim() !== '';
        }
    },

    mounted: function () {
        this.place = this.$parent.oldData.place;
    }
}
</script>

<style scoped>
.form-group input {
    width: 100%;
    text-align: left !important;
}

.form-group input::placeholder {
    color: lightgray;
}
</style>
